import { Outlet } from "react-router-dom";
import BranchForm from "./BranchForm";
import BranchList from "./BranchList";

export const adminBranchesRoutes = [
  {
    path: "branches",
    element: Outlet,
    children: [
      {
        path: "",
        element: BranchList,
      },
      {
        path: "list",
        element: BranchList,
      },
      {
        path: "add",
        element: BranchForm,
      },
      {
        path: "edit/:id",
        element: BranchForm,
      },
    ],
  },
];
